import React from 'react';
import socialNetworksJson from './contactJson.js';

const SocialNetworks = () => {
    return (
        <ul className='redes flexIndex'>
            {socialNetworksJson.map((social) => {
                let img = `${process.env.PUBLIC_URL}/images/social/${social.alt}.svg`;
                return (
                    <li key={social.titulo}>
                        <a href={social.link} target="_blank" rel="noopener noreferrer">
                            <i>
                                <img width="100%" src={img} alt={social.titulo}></img>
                            </i>
                        </a>
                    </li>
                )
            })}
        </ul>
    );
  };
  export default SocialNetworks;